export default "__VITE_ASSET__GRyXvCXh__"